import { Box, Button, ModalBody, ModalContent, ModalFooter, ModalHeader, Spinner, Text, Textarea } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { callToGetReviewEmailTemplate, callToSendReviewEmailTemplate, setIsCertificateStatusUpdated, setIsManualReviewEmailSendLoading } from '@/review/ducks/slice';
import { getIsCertificateStatusUpdated, getIsManualReviewEmailSendLoading, getIsReviewEmailTemplateLoading, getReviewEmailTemplate } from '@/review/components/selector';
import { Buffer } from 'buffer';

const handleLinkClick = (event: MouseEvent) => {
  if ((event.target as HTMLElement).tagName === 'A') {
    event.preventDefault();
  }
};

interface ManualReviewConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  isCancelBtnDisable: boolean;
  isConfirmBtnDisable: boolean;
  isConfirmBtnLoading: boolean;
  onClickConfirmBtn: () => void;
  id: string;
  reason: string;
  note: string;
}

const ManualReviewConfirmationModal = ({
  isOpen,
  onClose,
  isCancelBtnDisable,
  isConfirmBtnDisable,
  isConfirmBtnLoading,
  onClickConfirmBtn,
  id,
  reason = '',
  note = '',
}: ManualReviewConfirmationModalProps) => {

  const [currentTemplate, setCurrentTemplate] = useState<any>({});
  const dispatch = useDispatch();
  const reviewEmailTemplate = getReviewEmailTemplate();
  const isReviewEmailTemplateLoading = getIsReviewEmailTemplateLoading();
  const isManualReviewEmailSendLoading = getIsManualReviewEmailSendLoading();
  const isCertificateStatusUpdated = getIsCertificateStatusUpdated();
  const [rejectAndSendLoading, setRejectAndSendLoading] = useState<boolean>(false);

  useEffect(() => {
    if (id && id !== '' && !isReviewEmailTemplateLoading) {
      let payload:any = {
        id: id,
        rejected_reason: reason,
        note:note
      }

      dispatch(callToGetReviewEmailTemplate(payload));
    }
  }, []);

  
useEffect(() => {
    if (isCertificateStatusUpdated) {
      dispatch(setIsCertificateStatusUpdated(false));
      dispatch(callToSendReviewEmailTemplate({
          id: id,
          subject:  currentTemplate?.emailSubject,
          templateString: getHtmlContent(),
        }));
    }
  }, [isCertificateStatusUpdated])

  useEffect(() => {
    if (reviewEmailTemplate && reviewEmailTemplate?.emailSubject) {
      setCurrentTemplate(reviewEmailTemplate)
    }
  }, [reviewEmailTemplate])

  useEffect(() => {
    if (isManualReviewEmailSendLoading) {
      dispatch(setIsManualReviewEmailSendLoading(false));
      setRejectAndSendLoading(false)
    }
  }, [isManualReviewEmailSendLoading])

  // Function to convert buffer data to HTML string
  const getHtmlContent = () => {
    if (currentTemplate?.templateString) {
      // Check if it's buffer data or plain HTML
      if (typeof currentTemplate.templateString === 'string') {
        return currentTemplate.templateString;
      } else if (currentTemplate.templateString) {
        // Handle buffer data
        try {
          const htmlString = Buffer.from(currentTemplate.templateString).toString('utf8');
          return htmlString;
        } catch (error) {
          console.error('Error converting buffer to HTML:', error);
          return '<p>Error loading content</p>';
        }
      }
    }
    return '<p>No content available</p>';
  };


  return (
    <ModalContent className='confirmation-modal' maxWidth="800px !important" w="800px !important">
      <ModalHeader className='confirmation-modal__header'>
        <h2 className='confirmation-modal__title'>Manual Review Confirmation</h2>
        <button className='transfer-create-modal__close-btn' onClick={onClose}>
          <img src='/images/ui/close.svg' alt="Close" />
        </button>
      </ModalHeader>
      <ModalBody className='confirmation-modal__body' padding="40px 38.5px">
        <Text className='m-confirmation-modal__description'>
          System will trigger an email to dealer if you reject.
        </Text>
        {isReviewEmailTemplateLoading && (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '400px' }}>
            <Spinner
              className={`preview-loader`}
              thickness={'4px'}
              speed="0.65s"
              emptyColor={'gray.200'}
              color="#0C1E46"
              size={'xl'}
            />
          </Box>
        )}
        {!isReviewEmailTemplateLoading && reviewEmailTemplate && reviewEmailTemplate?.emailSubject && (
          <>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Text className='m-confirmation-modal__description' sx={{ margin: '1rem 0', fontWeight: 600, fontSize: '20px' }}>
                Email Preview
              </Text>
              
            </Box>
           <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '1rem' }}>
                <Text className='m-confirmation-modal__description' sx={{ fontSize: '18px', margin: '0 4.5rem', marginBottom: '1rem' }}>
                  <b>Subject :</b> {currentTemplate?.emailSubject}
                </Text>
                <Box
                  id="email-preview"
                  dangerouslySetInnerHTML={{ __html: getHtmlContent() }}
                />
              </Box>
          </>
        )}
      </ModalBody>
      <ModalFooter mt={3} className='confirmation-modal__footer'>
          <>
            <Button
              className='confirmation-modal__secondary-btn'
              isDisabled={isCancelBtnDisable}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                setRejectAndSendLoading(true)
                onClickConfirmBtn()
              }}
              isLoading={rejectAndSendLoading || isManualReviewEmailSendLoading}
              isDisabled={rejectAndSendLoading || isManualReviewEmailSendLoading}
              className='confirmation-modal__primary-btn'
              sx={{ minWidth: '170px' }}
            >
              Reject & Send Email
            </Button>
          </>
      </ModalFooter>
    </ModalContent>
  )
}

export default ManualReviewConfirmationModal